import { Directive, ElementRef, HostListener, Input, OnChanges } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'appLengthLimiter'
})
export class LengthLimiterDirective {
  @Input() maxLength: number;

  constructor(private el: ElementRef, private control: NgControl) {
  }

  @HostListener('input')
  inputEvenet() {
    const value = (this.el.nativeElement as HTMLInputElement).value
    if (value.length > this.maxLength) {
      this.control.control.setValue(value.slice(0, this.maxLength))
    }
  }

}
